<div *ngIf="activeTrip?.ticket "
     class="position-button  flex flex-col items-center" style="z-index: 999;">

  <div class="relative flex flex-col items-center">

    <!-- Bouton rond style taxi -->
    <button class="w-14 h-14 rounded-full bg-yellow-400 shadow-lg 
                   flex items-center justify-center text-black hover:bg-yellow-300 transition duration-200 "
                   (click)="returnToNotifyDriver()"
           >

      <!-- Icône taxi Material Icons -->
          <span class="material-icons text-4xl">local_taxi</span>

    </button>

    <!-- Message top-right, width fit-content -->
    <div class="absolute -top-10 -right-10">
      <div class="bg-white border border-gray-300 shadow-md rounded-lg 
                  text-sm text-gray-800 px-3 py-2 truncate w-max">

        <span *ngIf="isHasDriver(); else noDriver">
          {{ 'TRIP_NOTIFICATION.WITH_DRIVER' | translate:{
              driverName: activeTrip?.ticket?.driverFullName,
              destination: activeTrip?.ticket?.destinationAddress
          } }}
        </span>

        <ng-template #noDriver>
          <span>
            {{
                ('TRIP_NOTIFICATION.SEARCHING_NOW' | translate:{ destination: activeTrip?.ticket?.destinationAddress })
            }}
          </span>
        </ng-template>
      </div>
    </div>

  </div>
</div>
